/* unplugin-vue-components disabled */import script from "./RecordDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./RecordDrawer.vue?vue&type=style&index=0&id=0e0bc6a6&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e0bc6a6"]])

export default __exports__